import React, { Component } from "react";
import { Outlet } from "react-router-dom";
import withRouter from "../withRouter";
import { connect } from "react-redux";
import { styled } from "@mui/material/styles";

import { baseTheme } from "../../mui-theme";
import {
  Inbox,
  People,
  Apartment,
  LocalHotel,
  Equalizer,
} from "@mui/icons-material";
import {
  Divider,
  List,
  ListItemIcon,
  ListItemText,
  Drawer,
  ThemeProvider,
  ListItemButton,
} from "@mui/material";
import { ACTIONS, hasPermission } from "App/common/permissionHandler";

const userManagementKey = "user";
const execSummarykey = "exec";
const manageRoomsKey = "rooms";
const manageHotelKey = "hotel";
const manageCompSetKey = "CompSet";
const headerHeight = 44; // Standard Material-UI header height

const drawerWidth = 269;
const StyledDrawer = styled(Drawer)(() => ({
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    boxSizing: "border-box",
    marginTop: headerHeight,
    height: `calc(100% - ${headerHeight}px)`,
  },
}));

interface State {
  currentSelection: string;
  hashChange: string;
  isLoading: boolean;
}

interface Props {
  router: {
    location: {
      pathname: string;
    };
    navigate: (path: string) => void;
  };
  activeHotel: any;
  user: any;
}

class Settings extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentSelection: execSummarykey,
      hashChange: "",
      isLoading: false,
    };
  }

  static getDerivedStateFromProps(nextProps: Props) {
    const loc = nextProps.router.location.pathname;
    const hotelId = nextProps.activeHotel?.hotelId;

    if (hotelId) {
      const pathToSelection: { [key: string]: string } = {
        [`/${hotelId}/settings/rooms`]: manageRoomsKey,
        [`/${hotelId}/settings/executive-summary`]: execSummarykey,
        [`/${hotelId}/settings/user`]: userManagementKey,
        [`/${hotelId}/settings/hotel-config`]: manageHotelKey,
        [`/${hotelId}/settings/competitive-set`]: manageCompSetKey,
      };

      if (pathToSelection[loc]) {
        return { currentSelection: pathToSelection[loc] };
      }
    }
    return null;
  }

  componentDidMount() {
    const loc = this.props.router.location.pathname;
    const hotelId = this.props.activeHotel?.hotelId;

    if (loc === `/${hotelId}/settings` || loc === `/${hotelId}/settings/`) {
      this.props.router.navigate(`/${hotelId}/settings/executive-summary`);
    }
    console.log("Active hotel: ", this.props.activeHotel);
  }

  componentDidUpdate(prevProps: Props) {
    const hotelId = this.props.activeHotel?.hotelId;
    const loc = this.props.router.location.pathname;

    if (
      prevProps.router.location.pathname !== this.props.router.location.pathname
    ) {
      if (loc === `/${hotelId}/settings` || loc === `/${hotelId}/settings/`) {
        this.props.router.navigate(`/${hotelId}/settings/executive-summary`);
      }
    }
  }

  handleClick = (key: string) => {
    const hotelId = this.props.activeHotel?.hotelId;
    this.setState({ currentSelection: key });

    switch (key) {
      case userManagementKey:
        this.props.router.navigate(`/${hotelId}/settings/user`);
        break;
      case execSummarykey:
        this.props.router.navigate(`/${hotelId}/settings/executive-summary`);
        break;
      case manageRoomsKey:
        this.props.router.navigate(`/${hotelId}/settings/rooms`);
        break;
      case manageHotelKey:
        this.props.router.navigate(`/${hotelId}/settings/hotel-config`);
        break;
      case manageCompSetKey:
        this.props.router.navigate(`/${hotelId}/settings/competitive-set`);
        break;
      default:
        break;
    }
  };

  render() {
    return (
      <ThemeProvider theme={baseTheme}>
        <div style={{ display: "flex" }}>
          <StyledDrawer variant="permanent">
            <List>
              <ListItemButton
                selected={this.state.currentSelection === execSummarykey}
                onClick={() => this.handleClick(execSummarykey)}
              >
                <ListItemIcon>
                  <Equalizer />
                </ListItemIcon>
                <ListItemText primary="Executive Summary" />
              </ListItemButton>
              <Divider />
              {hasPermission(ACTIONS.MANAGE_PRO_HOTEL) &&
                this.props.activeHotel?.info?.level === "Pro" && (
                  <>
                    <ListItemButton
                      selected={
                        this.state.currentSelection === userManagementKey
                      }
                      onClick={() => this.handleClick(userManagementKey)}
                    >
                      <ListItemIcon>
                        <People />
                      </ListItemIcon>
                      <ListItemText primary="Users" />
                    </ListItemButton>
                    <Divider />
                  </>
                )}
              <ListItemButton
                selected={this.state.currentSelection === manageHotelKey}
                onClick={() => this.handleClick(manageHotelKey)}
              >
                <ListItemIcon>
                  <Apartment />
                </ListItemIcon>
                <ListItemText primary="Hotel Config" />
              </ListItemButton>
              <Divider />
              <ListItemButton
                selected={this.state.currentSelection === manageRoomsKey}
                onClick={() => this.handleClick(manageRoomsKey)}
              >
                <ListItemIcon>
                  <LocalHotel />
                </ListItemIcon>
                <ListItemText primary="Room Config" />
              </ListItemButton>
              <Divider />
              {hasPermission(ACTIONS.EDIT_COMPSET) && (
                <ListItemButton
                  selected={this.state.currentSelection === manageCompSetKey}
                  onClick={() => this.handleClick(manageCompSetKey)}
                >
                  <ListItemIcon>
                    <Inbox />
                  </ListItemIcon>
                  <ListItemText primary="Competitive Set" />
                </ListItemButton>
              )}
            </List>
          </StyledDrawer>
          <div
            style={{
              flexGrow: 1,
              padding: "24px",
              marginLeft: `${drawerWidth}px`,
              width: `calc(100% - ${drawerWidth}px)`,
              minHeight: `calc(100vh - ${headerHeight}px)`,
            }}
          >
            <Outlet />
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    activeHotel: state.hotelData.activeHotel,
    user: state.user,
  };
};

export default connect(mapStateToProps)(withRouter(Settings));
